import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import * as actions from "../../../store/actions";
import { path } from "../../../utils/constant";
import "./Header.scss";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobileMenuOpen: false,
      showSubMenu: false,
      isOpen: false,
    };
    this.menuRef = React.createRef();
  }

  //Toggle cho menu MObile
  toggleMobileMenu = () => {
    this.setState((prev) => ({
      isMobileMenuOpen: !prev.isMobileMenuOpen,
    }));
  };

  //Sự kiện khi click ra ngoài đóng menu mobile lại
  closeMobileMenu = () => {
    this.setState({ isMobileMenuOpen: false });
  };
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  handleClickOutside = (event) => {
    if (
      this.menuRef.current &&
      !this.menuRef.current.contains(event.target) &&
      this.state.isMobileMenuOpen
    ) {
      this.closeMobileMenu();
    }
  };
  //Sự kiện khi click ra ngoài đóng menu mobile lại

  handleRedirect = (product) => {
    this.props.history.push(`/product/${product}`);
  };

  handleChangeLanguage = (language) => {
    this.props.ChangeLanguage(language);
  };

  getLanguageLabel = () => {
    const { language } = this.props;
    switch (language) {
      case "vi":
        return "VI";
      case "en":
        return "EN";
      default:
        return "🌐 Language";
    }
  };
  handleToggleSubMenu = (e) => {
    e.preventDefault(); // Ngăn chuyển trang nếu thẻ <a> có href
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  };
  render() {
    let hrefDefault = "";
    const { isOpen } = this.state;
    let isActiveHome,
      isActiveFAQ,
      isActiveContact,
      isActiveAbout,
      isActiveProduct = "";
    let pathName = window.location.pathname;
    if (pathName === "/") {
      isActiveHome = true;
    } else if (pathName === "/about") {
      isActiveAbout = true;
    } else if (pathName === "/contact") {
      isActiveContact = true;
    } else if (pathName === "/faq") {
      isActiveFAQ = true;
    } else if (pathName === "/product/a5") {
      isActiveProduct = true;
    }
    return (
      <>
        <header id="header" className="header-section">
          <nav className="navbar">
            {/* Mobile Menu */}
            <div className="slicknav_menu">
              {/* <a
                aria-haspopup="true"
                role="button"
                tabIndex={0}
                className={`slicknav_btn ${
                  this.state.isMobileMenuOpen
                    ? "slicknav_open"
                    : "slicknav_closed"
                }`}
                style={{ outline: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.toggleMobileMenu();
                }}
              >
                <span className="slicknav_menutxt" />
                <span className="slicknav_icon slicknav_no-text">
                  {this.state.isMobileMenuOpen ? (
                    <span className="slicknav_close_icon">✕</span>
                  ) : (
                    <>
                      <span className="slicknav_icon-bar" />
                      <span className="slicknav_icon-bar" />
                      <span className="slicknav_icon-bar" />
                    </>
                  )}
                </span>
              </a> */}
              <button
                aria-haspopup="true"
                role="button"
                tabIndex={0}
                className={`slicknav_btn ${
                  this.state.isMobileMenuOpen
                    ? "slicknav_open"
                    : "slicknav_closed"
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  this.toggleMobileMenu();
                }}
              >
                <span className="slicknav_menutxt" />
                <span className="slicknav_icon slicknav_no-text">
                  {this.state.isMobileMenuOpen ? (
                    <span className="slicknav_close_icon">✕</span>
                  ) : (
                    <>
                      <span className="slicknav_icon-bar" />
                      <span className="slicknav_icon-bar" />
                      <span className="slicknav_icon-bar" />
                    </>
                  )}
                </span>
              </button>

              <ul
                className={`slicknav_nav ${
                  this.state.isMobileMenuOpen ? "menu-open" : "menu-closed"
                }`}
                aria-hidden={!this.state.isMobileMenuOpen}
                role="menu"
                ref={this.menuRef}
              >
                <li>
                  <Link
                    to={path.HOME}
                    className={`nav-link ${isActiveHome ? "active" : ""}`}
                    data-scroll="true"
                    role="menuitem"
                    tabIndex={0}
                  >
                    <FormattedMessage id="home.menu.a1" />
                  </Link>
                </li>
                <li
                  className="li-products-mobile"
                  // onMouseEnter={this.handleMouseEnter}
                  // onMouseLeave={this.handleMouseLeave}
                >
                  <Link
                    to={path.A5}
                    className={`nav-link ${isActiveProduct ? "active" : ""}`}
                  >
                    <FormattedMessage id="home.menu.a2" />
                  </Link>
                </li>
                {/* <li>
                  <a
                    href={hrefDefault.toString()}
                    onClick={this.handleToggleSubMenu}
                  >
                    <FormattedMessage id="home.menu.a6" />
                  </a>
                  {isOpen && (
                    <ul>
                      <li>
                        <Link to={path.PRIVACYPOLICY}>
                          <FormattedMessage id="footer.a1" />
                        </Link>
                      </li>
                      <li>
                        <Link to={path.REFUNDPOLICY}>
                          <FormattedMessage id="footer.a2" />
                        </Link>
                      </li>
                      <li>
                        <Link to={path.SHIPPINGPOLICY}>
                          <FormattedMessage id="footer.a3" />
                        </Link>
                      </li>
                      <li>
                        <Link to={path.TERM}>
                          <FormattedMessage id="footer.a4" />
                        </Link>
                      </li>
                    </ul>
                  )}
                </li> */}
                <li onClick={() => this.props.history.push("/order/a5")}>
                  <Link to={path.A5}>
                    <FormattedMessage id="order.a8" />
                  </Link>
                </li>
                {/* <li>
                  <Link
                    to={path.FAQ}
                    tabIndex={0}
                    className={`nav-link ${isActiveFAQ ? "active" : ""}`}
                  >
                    <FormattedMessage id="home.menu.a5" />
                  </Link>
                </li> */}
                <li>
                  <Link
                    to={path.CONTACT}
                    tabIndex={0}
                    role="menuitem"
                    className={`nav-link ${isActiveContact ? "active" : ""}`}
                  >
                    <FormattedMessage id="home.menu.a3" />
                  </Link>
                </li>
                <li>
                  <Link
                    to={path.ABOUT}
                    tabIndex={0}
                    role="menuitem"
                    className={`nav-link ${isActiveAbout ? "active" : ""}`}
                  >
                    <FormattedMessage id="home.menu.a4" />
                  </Link>
                </li>
                <li className="nav-item dropdown">
                  <button
                    className="nav-link dropdown-toggle item-button"
                    href="#"
                    id="langDropdown"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="true"
                  >
                    {this.props.language === "vi" ? (
                      <img
                        src="/static/images/flags/vn.png"
                        alt="none"
                        className="margin-right"
                      />
                    ) : (
                      <img
                        src="/static/images/flags/us.png"
                        alt="none"
                        className="margin-right"
                      />
                    )}
                    {this.getLanguageLabel()}
                  </button>
                  <div className="dropdown-menu" aria-labelledby="langDropdown">
                    <button
                      className="dropdown-item"
                      onClick={() => this.handleChangeLanguage("en")}
                    >
                      <img
                        src="/static/images/flags/us.png"
                        alt="none"
                        className="margin-right"
                      />
                      EN
                    </button>
                    <button
                      className="dropdown-item"
                      onClick={() => this.handleChangeLanguage("vi")}
                    >
                      <img
                        src="/static/images/flags/vn.png"
                        alt="none"
                        className="margin-right"
                      />
                      VI
                    </button>
                  </div>
                </li>
              </ul>
            </div>

            <Link className="navbar-brand" to={path.HOME}>
              <img
                src="/static/picture/logo-vn.png"
                alt="Saasbiz"
                className="img-brand"
              />
            </Link>

            {/* Desktop Menu */}
            <div className="d-flex menu-wrap">
              <div id="mainmenu" className="mainmenu">
                <ul className="nav">
                  <li>
                    <Link
                      to={path.HOME}
                      className={`nav-link ${isActiveHome ? "active" : ""}`}
                      data-scroll
                    >
                      <FormattedMessage id="home.menu.a1" />
                    </Link>
                  </li>
                  <li className="li-products">
                    <Link
                      to={path.A5}
                      className={`nav-link ${isActiveProduct ? "active" : ""}`}
                    >
                      <FormattedMessage id="home.menu.a2" />
                    </Link>
                  </li>
                  {/* <li className="list-term">
                    <a
                      href={hrefDefault.toString()}
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <FormattedMessage id="home.menu.a6" />
                    </a>
                    <ul>
                      <li>
                        <Link to={path.PRIVACYPOLICY}>
                          <FormattedMessage id="footer.a1" />
                        </Link>
                      </li>
                      <li>
                        <Link to={path.REFUNDPOLICY}>
                          <FormattedMessage id="footer.a2" />
                        </Link>
                      </li>
                      <li>
                        <Link to={path.SHIPPINGPOLICY}>
                          <FormattedMessage id="footer.a3" />
                        </Link>
                      </li>
                      <li>
                        <Link to={path.TERM}>
                          <FormattedMessage id="footer.a4" />
                        </Link>
                      </li>
                    </ul>
                  </li> */}
                  <li onClick={() => this.props.history.push("/order/a5")}>
                    <Link to={path.A5}>
                      <FormattedMessage id="order.a8_1" />
                    </Link>
                  </li>
                  {/* <li onClick={() => this.props.history.push("/faq")}>
                    <Link
                      to={path.FAQ}
                      className={`nav-link ${isActiveFAQ ? "active" : ""}`}
                    >
                      <FormattedMessage id="home.menu.a5" />
                    </Link>
                  </li> */}
                  <li onClick={() => this.props.history.push("/contact")}>
                    <Link
                      to={path.CONTACT}
                      className={`nav-link ${isActiveContact ? "active" : ""}`}
                    >
                      <FormattedMessage id="home.menu.a3" />
                    </Link>
                  </li>
                  <li onClick={() => this.props.history.push("/about")}>
                    <Link
                      to={path.ABOUT}
                      className={`nav-link ${isActiveAbout ? "active" : ""}`}
                    >
                      <FormattedMessage id="home.menu.a4" />
                    </Link>
                  </li>
                  <li className="nav-item dropdown">
                    <button
                      className="nav-link dropdown-toggle item-button"
                      href="#"
                      id="langDropdown"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="true"
                    >
                      {this.props.language === "vi" ? (
                        <img
                          src="/static/images/flags/vn.png"
                          alt="none"
                          className="margin-right"
                        />
                      ) : (
                        <img
                          src="/static/images/flags/us.png"
                          alt="none"
                          className="margin-right"
                        />
                      )}
                      {this.getLanguageLabel()}
                    </button>
                    <div
                      className="dropdown-menu"
                      aria-labelledby="langDropdown"
                    >
                      <button
                        className="dropdown-item"
                        onClick={() => this.handleChangeLanguage("en")}
                      >
                        <img
                          src="/static/images/flags/us.png"
                          alt="none"
                          className="margin-right"
                        />
                        EN
                      </button>
                      <button
                        className="dropdown-item"
                        onClick={() => this.handleChangeLanguage("vi")}
                      >
                        <img
                          src="/static/images/flags/vn.png"
                          alt="none"
                          className="margin-right"
                        />
                        VI
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </header>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  language: state.app.language,
});

const mapDispatchToProps = (dispatch) => ({
  ChangeLanguage: (language) => dispatch(actions.ChangeLanguage(language)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
